export default "__VITE_ASSET__Blp6wsiB__"